export default __webpack_public_path__ + "static/media/gallery - spells_05.df5473c3.jpg";